import Header
    from "../../components/header/header";
import VideoDemo
    from "../../components/videoDemo/videoDemo";
import React
    from "react";
import './homePage.css';
import TopNavBar from "../../components/topNavBar/topNavBar";
import AnimationBlock from "../../components/animationBlock/animationBlock";
import config from "../../config";

const HomePage = () => {
    return (
        <div className={"homePageWrapper"}>
            <TopNavBar />
            <div className={"lrPad"}>
                <Header />
                <div className="socialProofBanner">
                    <p className="socialProofUsers"><strong>200,000+</strong> people use Selectext</p>
                    <span className="socialProofDivider" aria-hidden="true" />
                    <div className="socialProofRating" aria-label="Rated 4.3 out of 5 from 640 plus reviews">
                        <strong>4.3</strong>
                        <span className="socialProofStars" aria-hidden="true">★★★★★</span>
                        <span className="socialProofReviews">640+ reviews</span>
                    </div>
                </div>
            </div>

            <AnimationBlock />
            <div className={"lrPad videoDemoSection"}>
                <VideoDemo url={config.promoVideoUrl}/>
            </div>
            {/* <LandingContentBlock /> */}
            
        </div>
    )
}

export default HomePage;
